import { useCallback } from 'react'
import { useToastController, Toast, ToastTitle, ToastBody } from '@fluentui/react-components'
import React from 'react'
import { TOASTER_ID } from '../components/toaster'

export type NotifyIntent = 'success' | 'error' | 'warning' | 'info'

export interface NotifyOptions {
  title: string
  /** Optional second line: what was affected, or why it failed. */
  body?: string
  intent?: NotifyIntent
}

/**
 * Raise a task pane notification.
 *
 * Office guidance is to confirm the outcome of an action inside the pane rather than
 * interrupting the document with a dialog, so every panel reports through one toaster.
 * Errors linger longer than confirmations because they have to be read.
 */
export const useNotify = () => {
  const { dispatchToast } = useToastController(TOASTER_ID)

  return useCallback(
    ({ title, body, intent = 'success' }: NotifyOptions) => {
      dispatchToast(
        React.createElement(
          Toast,
          null,
          React.createElement(ToastTitle, null, title),
          body ? React.createElement(ToastBody, null, body) : null
        ),
        { intent, timeout: intent === 'error' ? 8000 : 4000 }
      )
    },
    [dispatchToast]
  )
}
